import { TypePolicies } from '@apollo/client';

export const guestCachePolicies: TypePolicies = {
  EventSession: {
    merge: true,
  },
};
